import { useQuery, useQueryClient } from '@tanstack/react-query';

import { toAssignQuery } from '../api/crew.ts';
import { ShiftRow } from './crew-panel.tsx';

// CB-REQ CRW-11 at v1.980 – v1.996 (crew parts 3c and 4A): held days — people booked for a day
// before where they report is known — still without a place inside the company's window. Each is
// given its place (and the job it is for) on its own form, or released with a reason they see.

export function HeldDaysToAssign({
  mayManage,
  seesPrices,
}: {
  mayManage: boolean;
  seesPrices: boolean;
}) {
  const due = useQuery(toAssignQuery);
  const queryClient = useQueryClient();
  const refresh = async () => {
    await queryClient.invalidateQueries({ queryKey: ['shifts'] });
    await queryClient.invalidateQueries({ queryKey: ['jobs'] });
    await queryClient.invalidateQueries({ queryKey: ['roster'] });
  };
  if (!due.data || due.data.length === 0) return null;
  return (
    <section aria-labelledby="to-assign" className="flex flex-col gap-3">
      <h2 id="to-assign" className="section-title">
        Held days to place
      </h2>
      <p className="text-sm text-ink-soft">Booked with no venue yet. Place each, or release it.</p>
      <ul className="flex flex-col gap-2">
        {due.data.map((s) => (
          <ShiftRow
            key={s.id}
            shift={s}
            editable={mayManage}
            resolvable={false}
            seesPrices={seesPrices}
            onChanged={refresh}
          />
        ))}
      </ul>
    </section>
  );
}
